export const isErrorNotification = (notificationPayload) => {
  return typeof notificationPayload === 'string' 
    || (notificationPayload.response && notificationPayload.response.body)
}

export const notificationStyle = {
  error: "error",
  gray: "gray",
  success: "success"
}